module Tapas.Bindings {
    export class LoadMoreProducts {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var load = bindingContext.$root.load();
			var currentPage = valueAccessor().currentPage;
			var totalPages = valueAccessor().totalPages;

            var data = new Ftw.Data();
			var currentlyLoading = false;

			$(document).scroll(function () {
				if (totalPages > currentPage) {
					var nextPage = currentPage + 1;

					var loadElement = $(element).offset().top;
                    var y = $(document).scrollTop() + $(window).height();
					if (y >= loadElement && currentlyLoading == false) {
						currentlyLoading = true;
						load.active(true);
						load.text(valueAccessor().text);

						data.get(window.location.origin + window.location.pathname + (window.location.search ? window.location.search + "&" : "?") + "LayoutTemplate=Designs/Tapas/ajax_page.cshtml&ajaxTapas=true&pagenum=" + nextPage )
						.then((data) => {
							var productsHtml = $(data).children().html();
                            $(element).before(productsHtml);
                            var childBindingContext = bindingContext.createChildContext(viewModel);
                            ko.applyBindingsToDescendants(childBindingContext, document.getElementById(nextPage));
							currentPage++;
							bindingContext.$data.productListLoad(!bindingContext.$data.productListLoad());
						})
						.finally(() => {
							load.active(false);
							load.text("");
							currentlyLoading = false;
						});
					}
				}
			});
			
			$(window).unload(function () {
				load.active(false);
			});
        }
    }
    ko.bindingHandlers['loadMoreProducts'] = new LoadMoreProducts();
} 
